var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_2529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72917 6.77783C12.4111 6.77783 15.3958 5.8824 15.3958 4.77783C15.3958 3.67326 12.4111 2.77783 8.72917 2.77783C5.04727 2.77783 2.0625 3.67326 2.0625 4.77783C2.0625 5.8824 5.04727 6.77783 8.72917 6.77783Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72884 12.1112C9.61551 12.1112 10.1108 12.6165 10.3415 13.0552C10.3951 13.1596 10.4091 13.2798 10.3811 13.3937C10.353 13.5076 10.2848 13.6076 10.1888 13.6752C9.75664 13.963 9.24813 14.1149 8.72884 14.1112C8.17684 14.1112 7.66884 13.9478 7.26884 13.6745C7.17293 13.6069 7.10467 13.507 7.07662 13.393C7.04856 13.2791 7.06261 13.1589 7.11618 13.0545C7.34684 12.6178 7.84218 12.1112 8.72884 12.1112ZM8.72884 12.1112V6.77783",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_2529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.730469 0.444336)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRound);
export default __webpack_public_path__ + "static/media/table-round.c1a184bbf01e0cf8b6596f5080182391.svg";
export { ForwardRef as ReactComponent };